(() => {
  const selector = '.metafield-rich_text_field li strong';

  function initialize(root = document) {
    const containers = root.querySelectorAll('.or-product-helps');
    containers.forEach((container) => {
      if (container.dataset.helpsAnimationReady === 'true') return;
      container.dataset.helpsAnimationReady = 'true';

      const phrases = [...container.querySelectorAll(selector)];
      if (!phrases.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let current = 0;
      container.addEventListener('animationend', (event) => {
        if (event.animationName !== 'or-helps-underline' || event.target !== phrases[current]) return;
        phrases[current].classList.remove('is-active');
        current = (current + 1) % phrases.length;
        requestAnimationFrame(() => phrases[current].classList.add('is-active'));
      });
      phrases[0].classList.add('is-active');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
